// Route guard: redirects unauthenticated users to /signin.
// Wraps any route that requires a signed-in user.

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <FullScreenSpinner />;
  if (!user) {
    return <Navigate to="/signin" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

function FullScreenSpinner() {
  return (
    <div style={{ display: 'grid', placeItems: 'center', height: '100vh', color: 'var(--muted)' }}>
      Loading…
    </div>
  );
}
